import React from 'react';
import { Card, Badge, ProgressBar, Button, Modal } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAward } from '@fortawesome/free-solid-svg-icons';
import IconButton from 'components/common/IconButton';
import { useState, useEffect } from 'react';
import AddAchievementForm from './achievements/AddAchievementForm';
import AchievementService from './achievements/AchievementService';

const AchievementsCard = ({ data }) => {
  const [achievements, setAchievements] = useState();
  const [showModal, setShowModal] = useState(false);
  const [refreshCard, setRefreshCard] = useState(false);
  const getRarityColor = rarity => {
    switch (rarity) {
      case 'common':
        return 'secondary';
      case 'uncommon':
        return 'success';
      case 'rare':
        return 'info';
      case 'epic':
        return 'danger';
      default:
        return 'secondary';
    }
  };
  const refreshAchievementsCard = async () => {
    const unlocked = await AchievementService.retrieveUnlockedByProfile();
    const inProgress = await AchievementService.retrieveInProgressByProfile();
    const achievements = {
      recentlyUnlocked: unlocked,
      locked: inProgress
    };
    console.log('Achievements', achievements);
    const updatedAchievements = achievements || data;
    setAchievements(updatedAchievements);
  };
  useEffect(() => {
    refreshAchievementsCard();
  }, [refreshCard]);
  return (
    <>
      <Card className="h-100 border-0 shadow-sm wod-dark-card">
        <Card.Header className="bg-transparent border-bottom border-secondary">
          <div className="d-flex align-items-center">
            <FontAwesomeIcon icon={faAward} className="text-warning me-2" />
            <h5 className="mb-0 fw-bold">Achievements</h5>
            <IconButton
              icon="plus"
              className="btn btn-sm ms-auto"
              onClick={() => {
                setShowModal(true);
              }}
            >
              Add
            </IconButton>
          </div>
        </Card.Header>
        <Card.Body>
          <div className="mb-4">
            <h6 className="mb-3">Recently Unlocked</h6>
            <div className="d-flex flex-wrap gap-2">
              {achievements?.recentlyUnlocked.map(achievement => (
                <div
                  key={achievement.id}
                  className="p-3 rounded text-center"
                  style={{
                    backgroundColor: 'rgba(255,255,255,0.05)',
                    border: '1px solid rgba(255,255,255,0.1)',
                    width: '130px',
                    cursor: 'pointer',
                    transition: 'all 0.2s'
                  }}
                  title={achievement.description}
                >
                  <div className="fs-2 mb-1">{achievement.img?<img width="70" height="70" style={{ borderRadius:'10px'}} src={achievement.img} alt={achievement.name} />:achievement.icon}</div>
                  <small className="fw-semibold d-block mb-1">
                    {achievement.name}
                  </small>
                  <Badge
                    bg={getRarityColor(achievement.rarity)}
                    className="text-uppercase"
                    style={{ fontSize: '0.65rem' }}
                  >
                    {achievement.rarity}
                  </Badge>
                </div>
              ))}
            </div>
          </div>

          <div>
            <h6 className="mb-3">In Progress</h6>
            <div className="d-flex flex-column gap-3">
              {achievements?.locked.map(achievement => (
                <div
                  key={achievement.id}
                  className="p-3 rounded"
                  style={{
                    backgroundColor: 'rgba(255,255,255,0.05)',
                    border: '1px solid rgba(255,255,255,0.1)'
                  }}
                >
                  <div className="d-flex align-items-center mb-2">
                    <div className="fs-4 me-2 opacity-50">
                      {achievement.icon}
                    </div>
                    <div className="flex-grow-1">
                      <div className="fw-semibold">{achievement.name}</div>
                      <small>
                        {achievement.description}
                      </small>
                    </div>
                    <span className="text-warning fw-bold">
                      {achievement.progress.toFixed(0)}%
                    </span>
                  </div>
                  <ProgressBar
                    now={achievement.progress}
                    variant="warning"
                    style={{ height: '6px' }}
                  />
                </div>
              ))}
            </div>
          </div>
        </Card.Body>
      </Card>
      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        backdrop="static"
      >
        <Modal.Header>Add Achievement</Modal.Header>
        <Modal.Body>
          <AddAchievementForm refreshCard={setRefreshCard}></AddAchievementForm>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={() => setShowModal(false)} className="btn btn-sm">
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default AchievementsCard;
